<template>
  <ValidationObserver>
    <div v-if="phoneNumbersHasPrimary">
      <dp-base-phone-number
        :id="0"
        :key="0"
        class="my-4"
        :value="getPhoneNumbers[0].value"
        :phone-number-type="getPhoneNumbers[0].type"
        :validation-rules="validationRules"
        :phone-number-types="getPhoneNumberTypes"
        :show-remove-phone-number="false"
        @updatePhoneType="updatePhoneType"
        @updatePhoneNumber="updatePhoneNumber"
        @removePhoneTypeByIndex="removePhoneTypeByIndex"
      />
      <slot v-if="getPhoneNumbers.length > 1" name="optionalNumbersHeader"></slot>
      <dp-base-phone-number
        v-for="({ type, value }, index) in getPhoneNumbers.slice(1)"
        :id="index + 1"
        :key="index + 1"
        class="my-4"
        :value="value"
        :phone-number-type="type"
        :validation-rules="validationRules"
        :phone-number-types="getPhoneNumberTypes"
        :show-remove-phone-number="getPhoneNumbers.length > 1"
        @updatePhoneType="updatePhoneType"
        @updatePhoneNumber="updatePhoneNumber"
        @removePhoneTypeByIndex="removePhoneTypeByIndex"
      />
      <b-link v-show="getPhoneNumbers.length < types.length" @click="addNewPhoneNumber">{{
        $t('input.phoneNumber.addAnotherNumber')
      }}</b-link>
    </div>
    <div v-else>
      <dp-base-phone-number
        v-for="({ type, value }, index) in getPhoneNumbers"
        :id="index"
        :key="index"
        class="my-4"
        :value="value"
        :phone-number-type="type"
        :validation-rules="validationRules"
        :phone-number-types="getPhoneNumberTypes"
        :show-remove-phone-number="getPhoneNumbers.length > 1"
        @updatePhoneType="updatePhoneType"
        @updatePhoneNumber="updatePhoneNumber"
        @removePhoneTypeByIndex="removePhoneTypeByIndex"
      />
      <b-link v-show="getPhoneNumbers.length < types.length" @click="addNewPhoneNumber">{{
        $t('input.phoneNumber.addAnotherNumber')
      }}</b-link>
    </div>
  </ValidationObserver>
</template>

<script>
import { DpBasePhoneNumber } from '@docupet/component-library';
export default {
  name: 'BaseVPhoneNumbers',
  components: {
    DpBasePhoneNumber,
  },
  props: {
    mobilePhone: {
      type: String,
      default: '',
    },
    homePhone: {
      type: String,
      default: '',
    },
    workPhone: {
      type: String,
      default: '',
    },
    validationRules: {
      type: String,
      default: 'required|phoneNumber',
    },
    phoneNumbersHasPrimary: {
      type: Boolean,
      default: false,
    },
    primaryNumberType: {
      type: String,
      default: 'Home',
    },
    // To get flatten phone numbers object pass v-model of type object to this component
  },
  data() {
    return {
      types: [
        // Changing value prop value would change object property names which get's emitted (line:60 [output])
        { text: this.$t('dp.input.phoneNumber.mobilePhone'), value: 'M', disabled: false },
        { text: this.$t('dp.input.phoneNumber.homePhone'), value: 'H', disabled: false },
        { text: this.$t('dp.input.phoneNumber.workPhone'), value: 'W', disabled: false },
      ],
      phoneNumbers: [],
    };
  },
  computed: {
    getPhoneNumberTypes() {
      return this.types;
    },
    getPhoneNumbers() {
      return this.phoneNumbers;
    },
  },
  watch: {
    phoneNumbers: {
      handler: function (phoneNumberArr) {
        this.$emit(
          'input',
          phoneNumberArr.reduce(
            (phoneNumberObj, phoneNumber, index) => ({
              ...phoneNumberObj,
              [phoneNumber?.type]: this.phoneNumbersHasPrimary
                ? { value: phoneNumber?.value, isPrimaryPhoneType: index === 0 }
                : phoneNumber?.value,
            }),
            {}
          )
        );
      },
      deep: true,
    },
  },
  created() {
    if (this.mobilePhone || this.homePhone || this.workPhone) {
      if (this.mobilePhone) {
        this.phoneNumbers.push({ type: 'M', value: this.mobilePhone });
        this.types[0].disabled = true;
      }
      if (this.homePhone) {
        this.phoneNumbers.push({ type: 'H', value: this.homePhone });
        this.types[1].disabled = true;
      }
      if (this.workPhone) {
        this.phoneNumbers.push({ type: 'W', value: this.workPhone });
        this.types[2].disabled = true;
      }
    } else this.addNewPhoneNumber();

    if (this.phoneNumbersHasPrimary && this.primaryNumberType) this.swipePrimaryToZeroIndex();
  },
  methods: {
    addNewPhoneNumber() {
      const phoneType = this.types.filter((type) => type.disabled === false)[0];
      this.phoneNumbers.push({
        type: phoneType?.value || '',
        value: null,
      });
      // As this phoneType is now added we disable it from types
      phoneType.disabled = true;
    },
    updatePhoneType(oldPhoneType, newPhoneType, phoneNumbersIndex) {
      // We find newPhoneType in types and change 'disabled' to true and to false for oldPhoneType
      const newPhoneTypeObj = this.types.find((type) => type.value === newPhoneType);
      if (newPhoneTypeObj) {
        newPhoneTypeObj.disabled = true;
      }
      const oldPhoneObj = this.types.find((type) => type.value === oldPhoneType);
      if (oldPhoneObj) {
        oldPhoneObj.disabled = false;
      }

      this.phoneNumbers[phoneNumbersIndex].type = newPhoneType;
    },
    removePhoneTypeByIndex(phoneNumbersIndex) {
      if (this.phoneNumbers.length > 1) {
        this.types.find((type) => type.value === this.phoneNumbers[phoneNumbersIndex].type).disabled = false;
        this.phoneNumbers.splice(phoneNumbersIndex, 1);
      }
    },
    updatePhoneNumber(phoneNumber, phoneNumbersIndex) {
      this.phoneNumbers[phoneNumbersIndex].value = phoneNumber;
    },
    swipePrimaryToZeroIndex() {
      const currPrimaryIndex = this.phoneNumbers.map(({ type }) => type).indexOf(this.primaryNumberType);
      if (currPrimaryIndex === 0) return;
      else if (currPrimaryIndex !== -1)
        [this.phoneNumbers[0], this.phoneNumbers[currPrimaryIndex]] = [this.phoneNumbers[currPrimaryIndex], this.phoneNumbers[0]];
      else this.phoneNumbers.unshift({ type: this.primaryNumberType, value: '' });
    },
  },
};
/**
 * DEV NOTES
 * Idea: If phonenumber has primary type (e.g. PO) then we make sure that in phoneNumbers primary is always at zero index
 **/
</script>
